import { v4 as uuid } from 'uuid'

/**
 * 범용 고유 식별자 (UUID)를 생성
 *
 * UUID 문자열을 반환
 * `isSimple` 매개변수가 `true`로 설정되면, UUID의 첫 번째 부분만 반환
 * @example isSimple false: 9b1deb4d-4b3a-4f7b-bf83-1e1b2bca62af
 * @example isSimple true: 9b1deb4d
 * @param {boolean} [isSimple=false] - `true`로 설정되면 UUID의 첫 번째 부분만 반환
 */
export const useGenUUID = (
  isSimple: boolean = false
): ReturnType<typeof uuid> => {
  const id = uuid()

  return isSimple ? id.split('-')[0] : id
}
